export default "<div [id]=\"format\"></div>\n<div *ngIf=\"format === 'minread1'\" id=\"71M_inreadads\"></div>\n";